module.exports = __webpack_public_path__ + "static/media/buy_req_help_17.9c3444b5.jpg";